import { QuestionApplicableOnEnum } from '@/types/schema';

export enum QuestionManagerTabEnum {
  Active = 'active',
  Inactive = 'inactive',
}

export interface QuestionManagerProps {
  activeTab: QuestionManagerTabEnum;
  applicableOn: QuestionApplicableOnEnum;
  /** Overrides for embedding the manager under a page-owned header (e.g. Manage Surveys tabs). */
  viewProps?: {
    className?: string;
    classes?: { paddingTop?: string; search?: string };
    hideTitle?: boolean;
    /** Id of a DOM node to portal the create action into (instead of the manager header). */
    createEntityPortalId?: string;
  };
}
